import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { Subscription } from 'rxjs';
import {
  ListUsersLoggedUser,
  LogedUser,
} from '@base/src/app/core/models/logged-user.model';
import { Constants } from 'src/app/models/constants';
import { QRButton } from 'src/app/models/qr-button.model';
import { QRDropdown } from 'src/app/models/qr-dropdown.model';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { UserSessionService } from 'src/app/services/user-session.service';

@Component({
  selector: 'qr-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss'],
})
export class TopbarComponent implements OnInit {
  //--------------------Inputs & Outputs--------------------
  @Input() title!: string;
  @Input() isBackButtonVisible?: boolean = false;
  @Input() isFixedOnScrollUp?: boolean = false; // Para que la topbar se vea al scrollear para arriba
  @Input() isDropdownOfficeVisible: boolean = false; // Para mostrar la lista desplegable de oficinas del usuario
  @Output() back: EventEmitter<null> = new EventEmitter<null>();
  @Output() toggle: EventEmitter<number> = new EventEmitter<number>();
  @Output() update: EventEmitter<null> = new EventEmitter<null>();

  //--------------------Variables--------------------
  dropdownOfficesSelected: string | undefined;
  isTopbarFixed: boolean = false;
  oldScroll: number = 0;
  isFixedOnScrollUpEnable?: boolean = false; // Habilitar que cuando scrollea para arriba se muestre la topbar
  loggedUserSubscription: Subscription | undefined;
  loggedUser: LogedUser | undefined;
  listUsers: ListUsersLoggedUser[] = [];

  //--------------------Dropdowns--------------------
  dropdownOffices: QRDropdown = {
    hierarchy: QRDropdown.HIERARCHY_1,
    size: QRDropdown.SIZE_MEDIUM,
    placeholder: 'Seleccionar oficina',
    options: [],
  };

  //--------------------Buttons--------------------
  buttonBack: QRButton = {
    hierarchy: QRButton.HIERARCHY_4,
    size: QRButton.SIZE_MEDIUM,
    icon: Constants.ICONS.ARROW_BACK,
    iconOnly: true,
  };

  @HostListener('window:scroll', ['$event'])
  handleScroll() {
    if (!(this.isFixedOnScrollUpEnable && this.isFixedOnScrollUp)) {
      return;
    }

    const windowScroll = window.pageYOffset;
    this.isTopbarFixed =
      windowScroll > this.oldScroll ? false : windowScroll > 172;

    this.oldScroll = windowScroll;
  }

  //--------------------Constructor--------------------
  constructor(
    private readonly userSessionService: UserSessionService,
    private readonly snackbarService: SnackbarService
  ) {}

  //--------------------Functions--------------------
  ngOnInit(): void {
    this.loggedUserSubscription = this.userSessionService.loggedUser$.subscribe(
      (loggedUser) => {
        if (loggedUser != null) {
          this.loggedUser = loggedUser;
          this.listUsers = this.loggedUser.listUsers;
          if (this.listUsers.length != 0) {
            this.buildDropdownOffices();
          }
        }
      }
    );
  }

  ngOnDestroy(): void {
    this.loggedUserSubscription?.unsubscribe();
  }

  changedToggle(event: any) {
    this.toggle.emit(event);
  }

  buildDropdownOffices(): void {
    if (this.loggedUser) {
      this.isFixedOnScrollUpEnable = true;
      this.listUsers = this.loggedUser.listUsers;
      this.listUsers.forEach((user) => {
        this.dropdownOffices.options.push(user.agencyName);
      });
      let defaultUserSelected = this.dropdownOffices.options.find(
        (opt: string) => opt == this.loggedUser?.agency_name
      );
      this.dropdownOfficesSelected = defaultUserSelected;
    }
  }

  dropdownOfficeChange(selected: string | string[] | undefined): void {
    if (selected) {
      let userSelected: ListUsersLoggedUser | undefined = this.getUserSelected(
        selected?.toString()
      );
      this.userSessionService.userSelected = userSelected;
      this.snackbarService.openSnackBar(
        'Se ha cambiado a usuario ' +
          userSelected?.agencyName +
          ' (' +
          userSelected?.userFullName +
          ')',
        ''
      );
    }
  }
  clickUpdate() {
    this.update.emit();
  }

  getUserSelected(userSelected: string): ListUsersLoggedUser | undefined {
    let user: ListUsersLoggedUser | undefined;
    user = this.listUsers.find(
      (user: ListUsersLoggedUser) => user.agencyName == userSelected
    );
    return user;
  }

  backClick(): void {
    this.back.emit();
  }
}
